import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { bindActionCreators } from "redux";
import { Actions } from "../../Action";
import SkeletonLoader from "../../Component/SkeletonLoader/SkeletonLoader";
import QuestionBox from "../../Component/QuestionBox/NewQuestionBox";
import { useMediaQuery, useTheme } from "@mui/material";
import {
    getTrendingData,
    getFavouriteData,
    getTabSearchData,
    EXPERT_ANSWERED_COUNT,
    getAnsweredCount,
} from "../../API/api";
import { handleError } from "../../utils";
import { useLocation } from "react-router-dom";
import { CURRENT_ROLE } from "../../API/url";
import Switch from '@mui/material/Switch';
import { alpha, styled } from '@mui/material/styles';
import SearchBar from "../../NewComponent/SearchBar/SearchBar";
import Layout from "../../NewComponent/LayoutExpert/Layout";
import NewNestedSelect from "../../NewComponent/NewNestedSelect/NewNestedSelect";
import TabSearch from "../../NewComponent/TabSearch/tabSearch";
import PaginationComp from "../../NewComponent/Pagination/Pagination";
import { Select, Spin } from "antd";
import { Checkbox } from 'antd';
import Styles from './Styles.module.css'
import Tags from "./Tags";
import Question from "./Question";
import AnswereSortFilters from "./AnsweredSortFilter";
import { Empty } from "antd";
import Answer from "./Answer";
import NameInfo from "./Nameinfo";
import ActionBar from "./ActionBar";
import CachedIcon from '@mui/icons-material/Cached';
import TooltipComp from "../../NewComponent/ToolTip/TooltipComp";
;

const containerStyle = {
    border: "1px solid #E0E2E6",
    borderRadius: "16px",
    background: "#FFFFFF",
    boxShadow: "0px 4px 16px 0px #1018280F",
    padding: "24px 36px 24px 36px",
    minHeight: "100px",
    marginBottom: '24px',
    width: "100%"
};

const additionalContextStyles = {
    border: '1px solid rgb(246, 247, 248)',
    marginBlock: '10px',
    borderRadius: '6px',
    background: 'rgb(246, 247, 248)',
    padding: '12px',
    minHeight: '48px',
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
    wordBreak: 'break-word',overflowWrap: 'break-word',
}
const textStyles = {
    fontSize: "16px",
    color: "#2A364A",
    fontWeight: "500",
    // lineHeight: "24px",

    // wordBreak: "break-word",
    marginRight: "5px"

};

const filterTransferedQa = (data) => {
    return data.filter((item) => item.id !== 5)
}
export default function CuratedAnsweredPage() {
    const name = "answeredQuestions";
    let pageState = useSelector((state) => state[name]);
    const expertState = useSelector((state) => state.expertOpenData);
    const dispatch = useDispatch();
    const currentPath = useLocation();
    const editorState = useSelector((state) => state.editor);
    const [answerData, setAnswerData] = useState(null)
    const recommendState = useSelector((state) => state.recommend.isBack);
    const [loader, setLoader] = useState(true)
    const theme = useTheme();
    const [categoryCounts, setCategoryCounts] = useState({ 1: 0, 2: 0, 3: 0 });
    const isLargeScreen = useMediaQuery(theme.breakpoints.up("lg"));
    const [curatinColor, setCurationColor] = useState("")
    const userState = useSelector((state) => state.user);
    const [selectedAnswers, setSelectedAnswers] = useState([]);
    const [selectedFilters, setSelectedFilters] = useState([]);
    const [headFilter, setHeadFilter] = useState([]);
    const [curationStatusValue, setCurationStatusValue] = useState("");
    const [removeFilters, setRemoveFilter] = useState(null)
    const [transfered, setTransfered] = useState(pageState?.domains?.some(domain => domain.value === 'transferred') || pageState.isTransfered === true);
    const [curationFilter, setCurationFilter] = useState("")
    const [totalCount, setTotalCount] = useState(null)

    const {
        AnsweredPageBool,
        updateAnsweredSearchedQuery,
        updateAnsweredDomainValue,
        updateAnsweredSortFilterValue,
        IsLoadingAnsweredtab,
        updateAnsweredTabData,
        updatePageNoAnswered,
        updatePageNoFavourite,
        updatePageNoSharedBy,
        updatePageNoSharedWith,
        updateFavouriteSearchedQuery,
        updateFavouriteDomainValue,
        updateFavouriteSortFilterValue,
        IsLoadingFavouritetab,
        updateFavouriteTabData,
        updateSharedBySearchedQuery,
        updateSharedByDomainValue,
        updateSharedBySortFilterValue,
        IsLoadingSharedBytab,
        updateSharedByTabData,
        updateSharedWithSearchedQuery,
        updateSharedWithDomainValue,
        updateSharedWithSortFilterValue,
        IsLoadingSharedWithtab,
        updateSharedWithTabData,
        expertAnsweredSortFilter,
        savePageNumberAnswer,
        expertAnsweredFilter,
        getScrollPositionInExpertOpen, updateRatingBoolean, expertCurationChange, changeTransfered, changeCurationStatus
    } = bindActionCreators(Actions, dispatch);

    const container = {
        border: "1px solid #E0E2E6",
        borderRadius: "16px",
        background: "#FFFFFF",
        boxShadow: "0px 4px 16px 0px #1018280F",
        padding: "24px 36px 24px 36px",
        minHeight: "100px",
        marginBottom: '24px',
        width: "100%"
    };
    const filterContainer = {
        width: "76.6%",
        margin: "auto",
        // marginTop: "1%",
        // marginBottom: "7%",
        // border: "1px solid #E0E2E6",
        // background: "#FFFFFF",
        // borderRadius: "12px",
        // boxShadow: "0px 4px 16px 0px #1018280F",
        padding: "28px",
        paddingBottom: "0px",
        // position: "sticky",
        // top: 0,
        // zIndex: 1,

    };

    const containerStyle = {
        width: "74%",
        margin: "auto",
        marginTop: "1%",
        marginBottom: "7%",
        border: "1px solid #E0E2E6",
        background: "#FFFFFF",
        borderRadius: "12px",
        boxShadow: "0px 4px 16px 0px #1018280F",
        padding: "28px",

    };
    const AnswerContainerStyle = {
        width: "100%",
        margin: "auto",
        marginTop: "1%",
        marginBottom: "7%",
        border: "1px solid #E0E2E6",
        background: "#FFFFFF",
        borderRadius: "12px",
        boxShadow: "0px 4px 16px 0px #1018280F",
        padding: "28px",

    };

    const colorCodes = JSON.parse(process.env.REACT_APP_MY_COLOR_CODE);

    const CurationSwitch = styled(Switch)(({ theme }) => ({
        '& .MuiSwitch-switchBase.Mui-checked': {
            color: colorCodes['light_color_shade'],
            '&:hover': {
                backgroundColor: alpha(colorCodes['light_color_shade'], theme.palette.action.hoverOpacity),
            },
        },
        '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
            backgroundColor: colorCodes['light_color_shade'],
        },
    }));
    // console.log("statement", pageState.curationStatus)useF

    const [tabsearchQuery, SetTabSearchQuery] = useState(pageState.searchQuery);
    const searchBar = () => {
        return (
            <div style={{ width: '74%', margin: 'auto', marginTop: '1%', marginBottom: "3%" }}>
                <SearchBar />
            </div>
        );
    };
    const isCheckRelevance = (str) => {
        let isThere = false;
        for (let i = 0; i < str.length; ++i) {
            if (str[i].label === "Relevance") {
                isThere = true;
            }
        }
        return isThere;
    };
    const valId = pageState.data?.flatMap(item =>
        item.answersList
            ?.filter(val => val.expertUuid === userState.geoAttributes.userId)
            ?.map(val => val.answerUuid)
    ) || [];
    // console.log("answer", valId)

    // console.log("new", pageState.sortOptions)
    const FilterTab = ({ data }) => {
        const onChangeTabSearch = (e) => {
            AnsweredPageBool(true)
            updateRatingBoolean(true)
            updateAnsweredSearchedQuery(e.target.value);
            SetTabSearchQuery(e.target.value);
            if (e.target.value.length > 0) {
                if (!isCheckRelevance(pageState.sortOptions)) {
                    let sdf = pageState.sortOptions;
                    sdf.push(pageState.relevanceObj);
                    if (currentPath.pathname.includes("/answered")) {
                        updateAnsweredSortFilterValue(pageState.relevanceObj);
                    }
                    if (currentPath.pathname.includes("/favourite")) {
                        updateFavouriteSortFilterValue(pageState.relevanceObj);
                    }
                    if (currentPath.pathname.includes("/sharedby")) {
                        updateSharedBySortFilterValue(pageState.relevanceObj);
                    }
                    if (currentPath.pathname.includes("/sharedwith")) {
                        updateSharedWithSortFilterValue(pageState.relevanceObj);
                    }
                }
                SetTabSearchQuery(e.target.value);
                if (currentPath.pathname.includes("/answered")) {
                    updateAnsweredSearchedQuery(e.target.value);
                    updatePageNoAnswered(0);
                }
                if (currentPath.pathname.includes("/favourite")) {
                    updateFavouriteSearchedQuery(e.target.value);
                    updatePageNoFavourite(0);
                }
                if (currentPath.pathname.includes("/sharedby")) {
                    updateSharedBySearchedQuery(e.target.value);
                    updatePageNoSharedBy(0);
                }
                if (currentPath.pathname.includes("/sharedwith")) {
                    updateSharedWithSearchedQuery(e.target.value);
                    updatePageNoSharedWith(0);
                }
            }
            if (e.target.value.length === 0) {
                onResetTabSearch();
            }
        };
        const onChangeDomainSelect = (ad) => {
            if (currentPath.pathname.includes("/answered")) {
                updateAnsweredDomainValue(ad);
            }
            if (currentPath.pathname.includes("/favourite")) {
                updateFavouriteDomainValue(ad);
            }
            if (currentPath.pathname.includes("/sharedby")) {
                updateSharedByDomainValue(ad);
            }
            if (currentPath.pathname.includes("/sharedwith")) {
                updateSharedWithDomainValue(ad);
            }
        };

        const onChangeSortingSelect = (ad) => {
            AnsweredPageBool(true)
            updateRatingBoolean(true)

            getScrollPositionInExpertOpen(null)
            if (pageState.sortFilter.id === ad.id) {
                return;
            }
            if (currentPath.pathname.includes("/answered")) {
                updateAnsweredSortFilterValue(ad);
            }
            if (currentPath.pathname.includes("/favourite")) {
                updateFavouriteSortFilterValue(ad);
            }
            if (currentPath.pathname.includes("/sharedby")) {
                updateSharedBySortFilterValue(ad);
            }
            if (currentPath.pathname.includes("/sharedwith")) {
                updateSharedWithSortFilterValue(ad);
            }
        };

        const onResetTabSearch = () => {
            SetTabSearchQuery("");
            if (pageState.sortFilter.label === "Relevance") {
                if (currentPath.pathname.includes("/answered")) {
                    updateAnsweredSortFilterValue(pageState.sortOptions[0]);
                }
                if (currentPath.pathname.includes("/favourite")) {
                    updateFavouriteSortFilterValue(pageState.sortOptions[0]);
                }
                if (currentPath.pathname.includes("/sharedby")) {
                    updateSharedBySortFilterValue(pageState.sortOptions[0]);
                }
                if (currentPath.pathname.includes("/sharedwith")) {
                    updateSharedWithSortFilterValue(pageState.sortOptions[0]);
                }
            }
            if (currentPath.pathname.includes("/answered")) {
                updateAnsweredSearchedQuery("");
                updatePageNoAnswered(0);
            }
            if (currentPath.pathname.includes("/favourite")) {
                updateFavouriteSearchedQuery("");
                updatePageNoFavourite(0);
            }
            if (currentPath.pathname.includes("/sharedby")) {
                updateSharedBySearchedQuery("");
                updatePageNoSharedBy(0);
            }
            if (currentPath.pathname.includes("/sharedwith")) {
                updateSharedWithSearchedQuery("");
                updatePageNoSharedWith(0);
            }
            let sdf = pageState.sortOptions;
            sdf.pop();
        };
        const onClickExpertAnsweredSortFilter = (val) => {
            // console.log("window", window)
            getScrollPositionInExpertOpen(null)
            AnsweredPageBool(true)
            updateRatingBoolean(true)
            // getScrollPositionInExpertOpen(window.scrollY)
            let updatedValue = val === 'desc' ? 'asc' : 'desc';
            expertAnsweredSortFilter(updatedValue);
        }
        // console.log("rating",categoryCounts)

        const changeFilter = (value, isChecked) => {
            // console.log("change", value);
            getScrollPositionInExpertOpen(null)
            if (isChecked) {
                setSelectedAnswers(value);  // Select all answers
            } else {
                setSelectedAnswers([]);  // Deselect all answers
            }
        };

        const changeFilterVal = (value) => {
            // console.log("Clicked Filter:", value);
            getScrollPositionInExpertOpen(null)
            setSelectedAnswers([])
            updatePageNoAnswered(0)

            if (value === "0") {
                // Reset everything if "Curated" is clicked
                setCurationFilter((prev) => {
                    if (prev === "curated") return "";
                    return "curated";
                });

                setHeadFilter([]);
                setSelectedFilters([]);
                expertCurationChange([]);
                expertAnsweredFilter([]);
                changeCurationStatus(pageState.curationStatus === "curated" ? "" : "curated")
                return;
            }

            // Toggling logic
            setSelectedFilters((prevFilters) => {
                let updatedFilters;

                if (prevFilters.includes(value)) {
                    // Remove if already selected
                    updatedFilters = prevFilters.filter((item) => item !== value);
                } else {
                    // Add new value only
                    updatedFilters = [...prevFilters, value];
                }

                // Update curation status
                changeCurationStatus(updatedFilters.length > 0 ? "pending" : "")
                setCurationFilter(updatedFilters.length > 0 ? "pending" : "");

                const newExpertCuration = updatedFilters.map((val) => ({
                    value: val,
                    label: val,
                    name: val,
                }));

                // Sync updates
                expertCurationChange(newExpertCuration);
                setHeadFilter(updatedFilters); // This assumes headFilter is same as selected
                return updatedFilters;
            });
        };


        const low = pageState.expertCuration.filter((item) => item.value === "3");
        const high = pageState.expertCuration.filter((item) => item.value === "1");
        const medium = pageState.expertCuration.filter((item) => item.value === "2");
        // console.log("high", pageState);
        // console.log("medium", medium);
        // console.log("low", low);

        const onChangeTransfer = (val) => {
            getScrollPositionInExpertOpen(null)
            changeTransfered(val)
            updatePageNoAnswered(0)
            setTransfered(val)


        }
        const excludedValues = ['transferred', '1', '2', '3'];
        const filteredDomains = pageState?.expertDomain?.filter(domain => !excludedValues.includes(domain.value));
        // console.log("curationStatusValue",curationStatusValue)
        const categories = [
            { label: "High", count: curationStatusValue?.High !== undefined ? curationStatusValue?.High : 0, color: "from-red-400 to-orange-400", id: "1" },
            { label: "Medium", count: curationStatusValue?.Medium !== undefined ? curationStatusValue?.Medium : 0, color: "from-yellow-300 to-yellow-500", id: "2" },
            { label: "Low", count: curationStatusValue?.Low !== undefined ? curationStatusValue?.Low : 0, color: "from-green-300 to-green-500", id: "3" },
            { label: "Curated", count: curationStatusValue?.Curated !== undefined ? curationStatusValue?.Curated : 0, color: "from-blue-300 to-blue-500", id: "4" },
        ];

        return (
            <div >

                <div style={{ display: "flex", flexWrap: "wrap", paddingBottom: "7px" }}>


                    {/* next code */}
                    <div style={{ display: 'flex', justifyContent: 'space-between', flexWrap: 'wrap', paddingBottom: '12px', width: "100%" }}>
                        <div style={{ display: "flex", justifyContent: "space-between", width: "100%", flexWrap: "wrap", alignItems: "baseline" }}>


                            {pageState.curationStatus == "" && !transfered && tabsearchQuery.length == 0 && filteredDomains.length == 0 ? <div style={{
                                fontSize: '16px',
                                fontWeight: 500,
                                lineHeight: '24px',
                                textAlign: 'left',
                                color: '#2A364A',
                                // width: '40%',
                                display: 'flex',
                                justifyContent: 'space-between',
                                paddingTop: "2.1px",
                                paddingBottom: "5px"
                            }}>Total Answers&nbsp;{totalCount}

                            </div> : pageState.curationStatus !== "" && !transfered && tabsearchQuery.length == 0 && filteredDomains.length == 0 ? <div style={{
                                fontSize: '16px',
                                fontWeight: 500,
                                lineHeight: '24px',
                                textAlign: 'left',
                                color: '#2A364A',
                                // width: '40%',
                                display: 'flex',
                                justifyContent: 'space-between',
                                paddingTop: "1.5px",
                                paddingBottom: "5px"
                            }}>Filtered Answers&nbsp; 
                                {" "}{!pageState.isLoading && pageState.totalCount}{
                                    pageState.isLoading && "0"

                                }{pageState.curationStatus !== "" && ` of ${totalCount}`}

                            </div> : null}
                            {
                                transfered && filteredDomains.length == 0 && tabsearchQuery.length == 0 && <div style={{
                                    fontSize: '16px',
                                    fontWeight: 500,
                                    lineHeight: '24px',
                                    textAlign: 'left',
                                    color: '#2A364A',
                                    // width: '40%',
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    paddingTop: "1.5px",
                                    paddingBottom: "5px"
                                }}>Filtered Answers&nbsp; 
                                    {" "}{!pageState.isLoading && pageState.totalCount}{
                                        pageState.isLoading && "0"

                                    }{` of ${totalCount}`}

                                </div>
                            }
                            {
                                filteredDomains.length > 0 && tabsearchQuery.length == 0 && <div style={{
                                    fontSize: '16px',
                                    fontWeight: 500,
                                    lineHeight: '24px',
                                    textAlign: 'left',
                                    color: '#2A364A',
                                    // width: '40%',
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    paddingTop: "1.5px",
                                    paddingBottom: "5px"
                                }}>Filtered Answers&nbsp; 
                                    {" "}{!pageState.isLoading && pageState.totalCount}{
                                        pageState.isLoading && "0"

                                    }{` of ${totalCount}`}

                                </div>
                            }
                            {
                                tabsearchQuery.length > 0 && tabsearchQuery.length > 0 && <div style={{
                                    fontSize: '16px',
                                    fontWeight: 500,
                                    lineHeight: '24px',
                                    textAlign: 'left',
                                    color: '#2A364A',
                                    // width: '40%',
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    paddingTop: "1.5px",
                                    paddingBottom: "5px"
                                }}>Filtered Answers&nbsp; 
                                    {" "}{!pageState.isLoading && pageState.totalCount}{
                                        pageState.isLoading && "0"

                                    }{` of ${totalCount}`}

                                </div>
                            }

                            {/* pageState.domains */}
                            <div style={{ display: "flex", gap: "10px", alignItems: "center", marginBottom: "10px", flexWrap: "wrap" }}>

                                <span className={Styles.curationLabel} style={textStyles}>Curation Status&nbsp; </span>

                                <div role="button" onClick={() => changeFilterVal("1")} className={`${Styles.buttonContainer} ${selectedFilters.includes("1") || high.length > 0 ? Styles.active : ''}`}>
                                    <span className={Styles.currationText} >High&nbsp;  </span>
                                    <span className={Styles.curationBadgeHigh}>{curationStatusValue?.High !== undefined ? curationStatusValue?.High : 0}</span>
                                </div>
                                <div role="button" onClick={() => changeFilterVal("2")} className={`${Styles.buttonContainer} ${selectedFilters.includes("2") || medium.length > 0 ? Styles.active : ''}`}>
                                    <span className={Styles.currationText}
                                    >Medium&nbsp; </span>
                                    <span className={Styles.curationBadgeMedium}>{curationStatusValue?.Medium !== undefined ? curationStatusValue?.Medium : 0}</span>
                                </div>

                                <div role="button" onClick={() => changeFilterVal("3")} className={`${Styles.buttonContainer} ${selectedFilters.includes("3") || low.length > 0 ? Styles.active : ''}`}>
                                    <span className={Styles.currationText}>Low&nbsp; </span>
                                    <span className={Styles.curationBadgeLow}>{curationStatusValue?.Low !== undefined ? curationStatusValue?.Low : 0}</span>
                                </div>

                                <div role="button" onClick={() => changeFilterVal("0")} className={`${Styles.buttonContainer} ${pageState.curationStatus === "curated" ? Styles.active : ''}`}>
                                    <span className={Styles.currationText} >Curated&nbsp; </span>
                                    <span className={Styles.curationBadgeCurrent}>{curationStatusValue?.Curated !== undefined ? curationStatusValue?.Curated : 0}</span>
                                </div>
                                <div className="curation-item">
                                    <TooltipComp title={"Reset"}>
                                        {/* <CachedIcon style={{cursor:"pointer"}} onClick={resetValues}/>   */}

                                    </TooltipComp>
                                </div>
                                {/* <CachedIcon /> */}

                            </div>
                        </div>
                    </div>





                    <div style={{ display: "flex", justifyContent: "space-between", width: "100%", flexWrap: "wrap", alignItems: "baseline" }}>

                        <div style={{ display: "flex", flexWrap: "nowrap", width: "25%", paddingBottom: "5px" }}>
                            <Checkbox
                                checked={selectedAnswers.length === valId.length && valId.length > 0}
                                onChange={(e) => changeFilter(valId, e.target.checked)}
                                style={{
                                    fontSize: "24px",// Increases checkbox size
                                    marginRight: "5px",
                                    cursor: "pointer"
                                }}
                            />
                            <TabSearch width="100%" size="large" val={tabsearchQuery} onChangeFunc={(e) => {
                                AnsweredPageBool(true)
                                onChangeTabSearch(e)
                            }
                            } />
                        </div>
                        <div style={{ display: "flex", flexWrap: "nowrap", gap: "8px" }}>
                            <div style={{ display: 'flex', alignItems: "center", whiteSpace: "wrap" }}>
                                <span style={{ marginRight: "10px", fontSize: "16px", color: "#2A364A", fontWeight: "500", }}>
                                    Transferred?
                                </span>
                                <Checkbox
                                    checked={transfered}
                                    onChange={() => {
                                        onChangeTransfer(!transfered)
                                    }
                                    }
                                    sx={{
                                        fontSize: "24px",
                                        marginRight: "5px",
                                        cursor: "pointer"
                                    }}
                                />
                            </div>

                            {/* Sort Dropdown */}


                            {/* Sort Order Icon */}
                            {/* <div style={{display:"flex",alignItems:"baseline"}}>
                             
                            </div> */}

                            {/* Nested Selects */}
                            <div style={{ display: "flex", gap: "10px", minWidth: 200 }}>
                                {/* <NewNestedSelect tabsearchQuery={tabsearchQuery} show={1} setCurationFilter={setCurationFilter} 
                                setHeadFilter={setHeadFilter} 
                                setSelectedFilters={setSelectedFilters}
                                /> */}
                                <NewNestedSelect tabsearchQuery={tabsearchQuery} show={2} setCurationFilter={setCurationFilter} />

                            </div>
                            <div style={{ display: "flex", gap: "5px", minWidth: 180 }}>
                                <AnswereSortFilters
                                    onChangeFunc={onChangeSortingSelect}
                                    value={pageState.sortFilter}
                                    options={filterTransferedQa(pageState.sortOptions)}
                                />
                                <span
                                    className={`fa ${pageState.sortOrder === "desc" ? "fa-sort-amount-desc" : "fa-sort-amount-asc"}`}
                                    onClick={() => onClickExpertAnsweredSortFilter(pageState.sortOrder)}
                                    style={{ color: "grey", cursor: "pointer", fontSize: "22px", marginTop: "8px" }}
                                />

                            </div>
                        </div>

                    </div>




                </div>


            </div>

        );
    };

    const Loader = () => {
        return (
            <div className="trendingfilterbar">
                <SkeletonLoader />
            </div>
        );
    };

    const noDataAvailable = () => {
        return (
            <div>
                <Empty />
            </div>
        );
    };


    useEffect(() => {
        const isTransferred = pageState?.domains?.some(domain => domain.value === 'transferred') || pageState.isTransfered === true;
        // console.log("Transfered", expertState.getScrollPosition)
        // setTransfered(isTransferred)
        if (curationCategory.length > 0) {
            setCurationFilter("pending")
        }

        setSelectedFilters(pageState.expertCuration.map(item => item.value))
        // setSelectedFilters(pageState.domains)
    }, [])
    // console.log("pageState", pageState.domains)
    const excludedValues = ['transferred', '1', '2', '3']; // Exclude these from filteredDomains
    const curationValues = ['1', '2', '3']; // Values for curationCategory
    const prevDeps = useRef({});
    const isTransferred = pageState?.domains?.some(domain => domain.value === 'transferred'); // Check if 'transferred' exists

    const filteredDomains = pageState?.expertDomain?.filter(domain => !excludedValues.includes(domain.value)); // Remove 'transferred', '1', '2', '3'
    const curationCategory = pageState.expertCuration
        ?.filter(domain => curationValues.includes(domain.value)) // Get only '1', '2', '3'
        ?.map(domain => domain.value); // Extract values

    const searchCuration = curationCategory?.length > 0 ? curationCategory?.map(Number)?.join(",") : "";

    const searchDomain = filteredDomains?.length > 0 ? curationCategory : "";


    useEffect(() => {
        // console.log("first log")
        fetchDataCount()
    }, []);
    const fetchDataCount = (pageNo) => {
        setSelectedAnswers([])
        // console.log("pageState", pageState)\

        getAnsweredCount(
            pageState.pageNo !== undefined ? pageState.pageNo : 0,
            pageState.sortFilter.origValue,
            pageState.sortFilter.sortOrder !== undefined ? pageState.sortFilter.sortOrder : pageState.sortOrder,
            pageState.sortChange,
            // filteredDomains, // Filter out 'transferred'
            // "answered",
            // CURRENT_ROLE === "Expert" ? curationCategory : null,
            // CURRENT_ROLE === "Expert" ? transfered : null,
            // CURRENT_ROLE === "Expert" && pageState.curationStatus
        ).then((res) => {
            if (res === undefined) return;
            if (res.data.success) {
                // console.log("res",Object.keys(res.data.data))
                let val=Object.keys(res.data.data)[0]
                // console.log("val",res.data.data[val])
                const sum = Object.values(res.data.data[val]).reduce((total, num) => total + num, 0);
                setCurationStatusValue(res.data.data[val])
                setTotalCount(sum)
                // setCurationStatusValue(res.data.custom)
                // setTotalCount(res.data.count)
                // updateAnsweredTabData({
                //     data: res.data.data,
                //     count: res.data.count,
                // });
                // IsLoadingAnsweredtab(false);
            }
        })
            .catch((err) => {
                handleError(err);
            });
    };

    const fetchData = (pageNo) => {
        IsLoadingAnsweredtab(true);

        setSelectedAnswers([])
        // console.log("pageState", pageState)
        updateAnsweredTabData({
            data: [],
            count: 0,
        });


        if (name === "answeredQuestions") {
            if (
                tabsearchQuery?.length === 0 &&
                !isCheckRelevance(pageState.sortOptions)
            ) {
                // console.log("check",transfered)
                const isTransferred = pageState.domains.some(domain => domain.value === 'transferred');
                IsLoadingAnsweredtab(true);
                getTrendingData(
                    pageState.pageNo !== undefined ? pageState.pageNo : 0,
                    pageState.sortFilter.origValue,
                    pageState.sortFilter.sortOrder !== undefined ? pageState.sortFilter.sortOrder : pageState.sortOrder,
                    pageState.sortChange,
                    filteredDomains, // Filter out 'transferred'
                    "answered",
                    CURRENT_ROLE === "Expert" ? curationCategory : null,
                    CURRENT_ROLE === "Expert" ? transfered : null,
                    CURRENT_ROLE === "Expert" && pageState.curationStatus
                ).then((res) => {
                    if (res === undefined) return;
                    if (res.data.success) {

                        updateAnsweredTabData({
                            data: res.data.data,
                            count: res.data.count,
                        });
                        IsLoadingAnsweredtab(false);
                    }
                })
                    .catch((err) => {
                        handleError(err);
                    });
            }
            if (
                tabsearchQuery.length !== 0 &&
                isCheckRelevance(pageState.sortOptions)
            ) {
                IsLoadingAnsweredtab(true);
                // console.log("    pageState.sortOrder,", pageState.sortOrder)
                getTabSearchData(
                    pageState.pageNo !== undefined ? pageState.pageNo : 0,
                    "answered",
                    pageState.sortFilter.origValue,
                    tabsearchQuery,
                    pageState.sortOrder,
                    pageState.sortChange,
                    filteredDomains,
                    null,
                    CURRENT_ROLE === "Expert" ? curationCategory.join(",") : null,
                    CURRENT_ROLE === "Expert" ? transfered : null,
                    CURRENT_ROLE === "Expert" && pageState.curationStatus
                ).then((res) => {
                    if (res === undefined) return;
                    if (res !== undefined && res.data.success) {
                        IsLoadingAnsweredtab(false);
                        updateAnsweredTabData({
                            data: res.data.data,
                            count: res.data.count,
                        });
                        // fetchDataCount();

                    }

                });
            }
        } else {
            if (
                tabsearchQuery.length === 0 &&
                !isCheckRelevance(pageState.sortOptions)
            ) {
                let status;
                let category;
                if (currentPath.pathname.includes("/favourite")) {
                    IsLoadingFavouritetab(true);
                    status = "getfavourite";
                    category = 1;
                }
                if (currentPath.pathname.includes("/sharedby")) {
                    IsLoadingSharedBytab(true);
                    status = "getsharedbyme";
                    category = 2;
                }
                if (currentPath.pathname.includes("/sharedwith")) {
                    IsLoadingSharedWithtab(true);
                    status = "getsharedwithme";
                    category = 2;
                }

                getFavouriteData(
                    pageState.pageNo !== undefined ? pageState.pageNo : 0,
                    pageState.sortFilter.origValue,
                    pageState.sortFilter.sortOrder,
                    pageState.sortChange,
                    pageState.domains,
                    category,
                    status
                )
                    .then((res) => {
                        if (res === undefined) return;
                        if (res.data.success) {
                            if (currentPath.pathname.includes("/favourite")) {
                                IsLoadingFavouritetab(false);
                                updateFavouriteTabData({
                                    data: res.data.data,
                                    count: res.data.count,
                                });
                            }
                            if (currentPath.pathname.includes("/sharedby")) {
                                IsLoadingSharedBytab(false);
                                updateSharedByTabData({
                                    data: res.data.data,
                                    count: res.data.count,
                                });
                            }
                            if (currentPath.pathname.includes("/sharedwith")) {
                                IsLoadingSharedWithtab(false);
                                updateSharedWithTabData({
                                    data: res.data.data,
                                    count: res.data.count,
                                });
                            }
                        }
                    })
                    .catch((err) => {
                        handleError(err);
                    });
            }
            if (
                tabsearchQuery.length !== 0 &&
                isCheckRelevance(pageState.sortOptions)
            ) {
                let status;
                let category;
                if (currentPath.pathname.includes("/favourite")) {
                    IsLoadingFavouritetab(true);
                    status = "favorite";
                    category = 1;
                }
                if (currentPath.pathname.includes("/sharedby")) {
                    IsLoadingSharedBytab(true);
                    status = "sharedByMe";
                    category = 2;
                }
                if (currentPath.pathname.includes("/sharedwith")) {
                    IsLoadingSharedWithtab(true);
                    status = "sharedWithMe";
                    category = 2;
                }
                getTabSearchData(
                    pageState.pageNo !== undefined ? pageState.pageNo : 0,
                    status,
                    pageState.sortFilter.origValue,
                    tabsearchQuery,
                    pageState.sortOrder,
                    pageState.sortChange,
                    pageState.domains,
                    category
                )
                    .then((res) => {
                        if (res === undefined) return;
                        if (res.data.success) {
                            if (currentPath.pathname.includes("/favourite")) {
                                IsLoadingFavouritetab(false);
                                updateFavouriteTabData({
                                    data: res.data.data,
                                    count: res.data.count,
                                });
                            }
                            if (currentPath.pathname.includes("/sharedby")) {
                                IsLoadingSharedBytab(false);
                                updateSharedByTabData({
                                    data: res.data.data,
                                    count: res.data.count,
                                });
                            }
                            if (currentPath.pathname.includes("/sharedwith")) {
                                IsLoadingSharedWithtab(false);
                                updateSharedWithTabData({
                                    data: res.data.data,
                                    count: res.data.count,
                                });
                            }
                        }
                        fetchDataCount()
                    })
                    .catch((err) => {
                        handleError(err);
                    });
            }
        }
    };

    const fetchMore = () => {
        if (currentPath.pathname.includes("/answered")) {
            let totalCount = pageState.totalCount;
            let currentDataCount = pageState.data.length;
            let upcomingPage = pageState.pageNo + 1;
            if (currentDataCount < totalCount) {
                setTimeout(() => {
                    updatePageNoAnswered(upcomingPage);
                }, 500);
            }
        }
        if (currentPath.pathname.includes("/favourite")) {
            let totalCount = pageState.totalCount;
            let currentDataCount = pageState.data.length;
            let upcomingPage = pageState.pageNo + 1;
            if (currentDataCount < totalCount) {
                setTimeout(() => {
                    updatePageNoFavourite(upcomingPage);
                }, 500);
            }
        }
        if (currentPath.pathname.includes("/sharedby")) {
            let totalCount = pageState.totalCount;
            let currentDataCount = pageState.data.length;
            let upcomingPage = pageState.pageNo + 1;
            if (currentDataCount < totalCount) {
                setTimeout(() => {
                    updatePageNoSharedBy(upcomingPage);
                }, 500);
            }
        }
        if (currentPath.pathname.includes("/sharedwith")) {
            let totalCount = pageState.totalCount;
            let currentDataCount = pageState.data.length;
            let upcomingPage = pageState.pageNo + 1;
            if (currentDataCount < totalCount) {
                setTimeout(() => {
                    updatePageNoSharedWith(upcomingPage);
                }, 500);
            }
        }
    };


    useEffect(() => {
        const changedDeps = {};
        const currentDeps = {
            answeredBoolean: editorState.answeredBoolean,
            domains: pageState.domains,
            sortFilter: pageState.sortFilter,
            tabsearchQuery,
            pageNo: pageState.pageNo,
            reload: pageState.reload,
            sortOrder: pageState.sortOrder,
            curationStatus: pageState.curationStatus,
        };

        Object.keys(currentDeps).forEach((key) => {
            if (prevDeps.current[key] !== currentDeps[key]) {
                changedDeps[key] = {
                    from: prevDeps.current[key],
                    to: currentDeps[key],
                };
            }
        });

        prevDeps.current = { ...currentDeps };
        updateRatingBoolean(true)
        fetchData();

    }, [
        // editorState.answeredBoolean,
        pageState.domains,
        pageState.sortFilter,
        tabsearchQuery,
        pageState.pageNo,
        pageState.reload,
        pageState.sortOrder,
        pageState.curationStatus,
        transfered,
        pageState?.expertDomain,
        pageState?.expertCuration,
        pageState?.isTransfered,
        pageState?.curationStatus
    ]);
    // useEffect(() => {
    //     if(editorState.answeredBoolean!==undefined){
    //         AnsweredPageBool(true);
    //     }

    //   }, []);


    useEffect(() => {
        const countCategories = () => {
            const counts = { 1: 0, 2: 0, 3: 0 };

            pageState.data.forEach((answer) => {
                answer.answersList.forEach((answer) => {
                    if (answer.curationStatus === "pending") {
                        const category = answer.curationCategory;
                        if ([1, 2, 3].includes(category)) {
                            counts[category]++;
                        }
                    }
                })

            });

            setCategoryCounts(counts);
        };

        countCategories();
    }, [pageState.data]);

    useEffect(() => {
        return () => {
            updatePageNoAnswered(0)
            //   dispatch(updateValue("Updated before leaving"));/
        };
    }, []);

    useEffect(() => {
        const scrollPos = expertState.getScrollPosition;
        if (typeof scrollPos === 'number' && !isNaN(scrollPos)) {
            window.scrollTo({ top: scrollPos, behavior: 'smooth' });
        }
    })
    const onChangePageEvent = (e) => {
        // updatePageNoAnswered()
        getScrollPositionInExpertOpen(null)
        AnsweredPageBool(true)
        updateRatingBoolean(true)
        savePageNumberAnswer(e - 1)
        updatePageNoAnswered(e - 1)
    }

    const rating = editorState?.ratingBool === true && pageState.isLoading ? true : false
    const handleCheckboxChange = (answerUuid, isChecked) => {
        getScrollPositionInExpertOpen(null)
        setSelectedAnswers(prev =>
            isChecked
                ? [...prev, answerUuid]  // Add answer to selected list
                : prev?.filter(id => id !== answerUuid)  // Remove answer from selected list
        );
    };

    // console.log("selectedAnswers", selectedAnswers)
    return (
        <>
            <Layout>

                {searchBar()}

                <div style={containerStyle}>
                    <FilterTab data={pageState?.data} />

                    {/* {filterTab()} */}
                    {
                        rating && (
                            <div style={{ display: 'flex', justifyContent: 'center', minHeight: '15vh' }}>
                                <Spin spinning={true} size={'large'}>
                                </Spin>
                            </div>
                        )
                    }
                    {!rating && pageState.data.length > 0 && pageState.data?.map((qa, index) => {

                        //    cons
                        const isOwnedByUser = qa.answersList.map((item) => {
                            // console.log("item", item)
                            if (item.expertUuid === userState.geoAttributes.userId) {
                                return true
                            }
                            else return false
                        })
                        // console.log("first", qa)
                        // console.log("owner",isOwnedByUser)
                        return <div style={{ display: "flex", width: "100%" }}>
                            <div key={qa.answerUuid} style={{ display: "flex", flexDirection: "column", justifyContent: "center", marginRight: "8px" }}>
                                {
                                    qa.answersList.map((item) => {
                                        return <>
                                            {
                                                item.expertUuid === userState.geoAttributes.userId && <span key={item.expertUuid}>
                                                    <Checkbox
                                                        checked={selectedAnswers?.includes(item.answerUuid)}
                                                        onChange={e => handleCheckboxChange(item.answerUuid, e.target.checked)}

                                                    />
                                                </span>
                                            }



                                        </>
                                    })
                                }




                            </div>

                            <div style={container}>

                                <Question question={qa} tabsearchQuery={tabsearchQuery} curationFilter={curationFilter} fetchData={fetchData} fetchDataCount={fetchDataCount} />
                                {
                                    qa.additionalContext.length > 0 && <div style={additionalContextStyles}>
                                        {qa.additionalContext}
                                    </div>
                                }

                                <Tags data={qa} />
                                {qa?.answersList?.map((answer, index) => {
                                    return (
                                        <>
                                            <NameInfo data={answer} question={qa} />
                                            <Answer data={answer} question={qa} tabsearchQuery={tabsearchQuery} fetchData={fetchData}
                                                fetchDataCount={fetchDataCount} />
                                            {qa.answersList.length - 1 !== index && <p className={Styles.onSelectedtab} style={{ marginBottom: '10px', marginTop: '15px' }}></p>}
                                        </>
                                    )
                                })}
                            </div>
                        </div>
                    })

                    }
                    {/* {pageState.data.length > 0 && renderQApair(pageState.data)} */}
                    {!rating &&
                        pageState.data.length === 0 && !pageState.isLoading &&
                        noDataAvailable()}
                    {(rating === false) && pageState.data.length > 0 && <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                        <PaginationComp page={pageState.pageNo !== undefined ? pageState.pageNo + 1 : 1} total={pageState.totalCount}
                            onChangeFunc={onChangePageEvent}
                        />
                    </div>
                    }
                    {
                        selectedAnswers.length > 0 && <ActionBar
                            selectedCount={selectedAnswers.length}
                            onSelectAll={() => {
                                setSelectedAnswers(valId)
                            }}
                            selectedAnswers={selectedAnswers}
                            tabsearchQuery={tabsearchQuery}
                            setSelectedAnswers={setSelectedAnswers}

                            curationFilter={curationFilter}
                            fetchData={fetchData}
                            fetchDataCount={fetchDataCount}
                        />
                    }


                </div>


            </Layout>
        </>
    );
}
